import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Primary reusable button / link component.
 *
 * Props:
 *  variant  – 'primary' | 'outline' | 'outline-light'  (default: 'primary')
 *  size     – 'sm' | 'md' | 'lg'                        (default: 'md')
 *  to       – internal route (renders <Link>)
 *  href     – external URL (renders <a target="_blank">)
 *  type     – button type attribute                      (default: 'button')
 *  onClick  – click handler
 *  disabled – boolean
 *  children – button label / content
 */
function Button({
  variant = 'primary',
  size,
  to,
  href,
  type = 'button',
  onClick,
  disabled = false,
  className = '',
  children,
  ...rest
}) {
  const baseClass = (() => {
    switch (variant) {
      case 'outline':       return 'btn-outline-brand';
      case 'outline-light': return 'btn-outline-light';
      case 'outline-dark':  return 'btn-outline-dark';
      default:              return 'btn-primary-brand';
    }
  })();

  const sizeClass = size === 'sm' ? ' btn-sm' : size === 'lg' ? ' btn-lg' : '';
  const fullClass = `${baseClass}${sizeClass}${className ? ` ${className}` : ''}`;

  if (to) {
    return (
      <Link to={to} className={fullClass} {...rest}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a
        href={href}
        className={fullClass}
        target="_blank"
        rel="noopener noreferrer"
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      type={type}
      className={fullClass}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
}

export default Button;
